import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

export default function StudentHeader({ userRole, setIsLoginOpen, setIsSignupOpen, logout }) {
  const nav = useNavigate();
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const id = setInterval(() => setStep(p => (p + 1) % 5), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const h = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  const publicMenu = ['Home', 'Courses', 'Certifications', 'Mentorship'];
  const privateMenu = [...publicMenu, 'My Discussions', 'Get Self Assessment', 'Dashboard'];
  const menu = userRole ? privateMenu : publicMenu;

  const handle = txt => {
    setOpen(false);
    const go = path => nav(path);
    switch (txt) {
      case 'Home':
        if (userRole === 'student') {
          go('/home'); // Go to student home instead of dashboard
        } else {
          go('/');
        }
        break;
      case 'Courses': go('/student/courses'); break;
      // case 'Webinars': window.open('https://learn.robokalam.com/sessions#all', '_blank'); break;
      case 'Certifications': go('/student/certifications'); break;
      case 'Mentorship': go('/student/aboutmentor'); break;
      case 'My Discussions': go('/student/discussions'); break;
      case 'Dashboard': go('/student/dashboard'); break;
      case 'Get Self Assessment': window.open('https://ai-microapp-template-development.streamlit.app/?template=Career+Advisor', '_blank'); break;
      default: break;
    }
  };

  return (
    <>
      <header className="navbar-container">
        <div className="top-row">
          <div
            className="logo"
            onClick={() => {
              if (userRole === 'student') {
                nav('/home');
              } else {
                nav('/');
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <img src="/footer/Robokalam Logo Real header 1.png" alt="Robokalam Logo" className="logo" />
          </div>

          <div className="top-center">
            <nav className="menu">
              {menu.map(m => (
                <button
                  key={m}
                  onClick={() => handle(m)}
                  style={
                    m === 'Get Self Assessment'
                      ? { backgroundColor: '#ff6600', color: '#ffffff' }
                      : {}
                  }
                >
                  {m}
                </button>
              ))}
            </nav>
          </div>

          <div className="top-actions">
            {!userRole && (
              <>
                <button className="login-btn" onClick={() => setIsLoginOpen(true)}>Login →</button>
                <button className="signup-btn" onClick={() => setIsSignupOpen(true)}>Sign up →</button>
              </>
            )}
            {userRole && (
              <button className="login-btn" onClick={logout}>Logout →</button>
            )}
          </div>

          <div className="hamburger" onClick={() => setOpen(true)}>☰</div>
        </div>

        <div className="bottom-row">
          <h1 className="title">KodeZ –
            {step >= 1 && <span className="animated-word"> Learn.</span>}
            {step >= 2 && <span className="animated-word"> Launch.</span>}
            {step >= 3 && <span className="animated-word"> Lead.</span>}
          </h1>
        </div>
      </header>

      {open && (
        <div className="side-popup-overlay">
          <div className="side-popup" ref={ref}>
            {menu.map(m => (
              <button
                key={m}
                onClick={() => handle(m)}
                style={
                  m === 'Get Self Assessment'
                    ? { backgroundColor: '#ff6600', color: '#ffffff' }
                    : {}
                }
              >
                {m}
              </button>
            ))}
            {userRole ? (
              <button onClick={logout}>Logout</button>
            ) : (
              <>
                <button onClick={() => { setIsLoginOpen(true); setOpen(false); }}>Login</button>
                <button onClick={() => { setIsSignupOpen(true); setOpen(false); }}>Sign up</button>
              </>
            )}
          </div>

        </div>
      )}
    </>
  );
}
